import "./Home.css"
import { Link } from "react-router-dom"

export default function Home() {
    const scrollDx = () => {
        var dx = document.querySelector(".slideshow_home");
        dx.scrollBy(350, 0)
    }
    const scrollSx = () => {
        var sx = document.querySelector(".slideshow_home");
        sx.scrollBy(-350, 0)
    }

    return (
        <section>
            <h1>
                Infis Lab: rivendita e installazione di infissi e complementi,
                progettazione di interni, interior design.
            </h1>
            <br />
            <div className="cover"><div className="slideshow_home">
                <div className="slideshow_element_home">
                    <img className="img_home" src="https://infislab.it/foto/sezioni/home (1).jpg" loading="lazy"></img>
                </div>
                <div className="slideshow_element_home">
                    <img className="img_home" src="https://infislab.it/foto/sezioni/home (2).jpg" loading="lazy"></img>
                </div>
                <div className="slideshow_element_home">
                    <img className="img_home" src="https://infislab.it/foto/sezioni/home (3).jpg" loading="lazy"></img>
                </div>
                <div className="slideshow_element_home">
                    <img className="img_home" src="https://infislab.it/foto/sezioni/home (4).jpg" loading="lazy"></img>
                </div>
                <div className="slideshow_element_home">
                    <img className="img_home" src="https://infislab.it/foto/sezioni/home (5).jpg" loading="lazy"></img>
                </div>
            </div></div>
            <div className="frecce_home">
                <ion-icon id="frecce_slideshow" onClick={scrollSx} name="chevron-back-outline"></ion-icon>
                <p className="help">
                    scorri per visualizzare le immagini
                </p>
                <ion-icon id="frecce_slideshow" onClick={scrollDx} name="chevron-forward-outline"></ion-icon>
            </div>
            <br />
            <div className="icons_about">
                <p>
                    Visita la nostra <a className="a_about"
                    href="https://it-it.facebook.com/infislab/" target="_blank">pagina Facebook</a> e scopri tutti
                    i lavori più recenti: installazioni in corso,
                    commissioni completate e proposte dei nostri partner. Leggi commenti e
                    recensioni di chi ha scelto di affidarsi a noi, facci domande, o lascia
                    il tuo feedback se sei già stato nostro cliente.
                </p>
            </div>
            <br />
            <div className="icons_about">
                <ion-icon id="icone_home" name="images-outline"></ion-icon>
                <p className="caption">
                    Sulla nostra <Link className="a_about" to="/gallery/">galleria</Link> puoi
                    trovare un'ampia raccolta di foto scattate in corso d'opera: 
                    porte, finestre, cancelli, ringhiere e molto altro.
                </p>
            </div>
        </section>
    )
}